import React from 'react';

import RefreshButton from '../../common/refreshbutton';
import SearchBar from '../common/SearchBar';
import { BaseDropDown } from '../common/dropdowns';
import { getSafeSelectedFilter } from './helpers';
import { TFilterChangePayload, TFilterOptionsToDisplay } from './types';

type TGlobalFreelancersFiltersProps = {
    currentUrlParams: URLSearchParams;
    filterOptionValuesToDisplay: TFilterOptionsToDisplay;
    onFilterChange: (
        id: string,
        value: TFilterChangePayload | string | null,
    ) => void;
    reloadData: () => void;
};

export const GlobalFreelancersFilters = ({
    currentUrlParams,
    filterOptionValuesToDisplay,
    onFilterChange,
    reloadData,
}: TGlobalFreelancersFiltersProps) => (
        <div className="table-filter-container">
            <BaseDropDown
                filterKey="service_key"
                selected={getSafeSelectedFilter(
                    currentUrlParams.get('service_key'),
                    filterOptionValuesToDisplay.serviceKey,
                )}
                options={filterOptionValuesToDisplay.serviceKey}
                defaultSelection={filterOptionValuesToDisplay.serviceKey[0]}
                onFilterChange={onFilterChange}
            />
            <BaseDropDown
                filterKey="interview_status"
                selected={getSafeSelectedFilter(
                    currentUrlParams.get('interview_status'),
                    filterOptionValuesToDisplay.interviewStatus,
                )}
                options={filterOptionValuesToDisplay.interviewStatus}
                defaultSelection={
                    filterOptionValuesToDisplay.interviewStatus[0]
                }
                onFilterChange={onFilterChange}
            />
            <BaseDropDown
                filterKey="is_published"
                selected={getSafeSelectedFilter(
                    currentUrlParams.get('is_published'),
                    filterOptionValuesToDisplay.isPublished,
                )}
                options={filterOptionValuesToDisplay.isPublished}
                defaultSelection={filterOptionValuesToDisplay.isPublished[0]}
                onFilterChange={onFilterChange}
            />
            <BaseDropDown
                filterKey="is_archived"
                selected={getSafeSelectedFilter(
                    currentUrlParams.get('is_archived'),
                    filterOptionValuesToDisplay.isArchived,
                )}
                options={filterOptionValuesToDisplay.isArchived}
                defaultSelection={filterOptionValuesToDisplay.isArchived[0]}
                onFilterChange={onFilterChange}
            />
            <BaseDropDown
                filterKey="is_active"
                selected={getSafeSelectedFilter(
                    currentUrlParams.get('is_active'),
                    filterOptionValuesToDisplay.isActive,
                )}
                options={filterOptionValuesToDisplay.isActive}
                defaultSelection={filterOptionValuesToDisplay.isActive[0]}
                onFilterChange={onFilterChange}
            />
            <SearchBar
                filterKey="search"
                customPlaceHolder="Search..."
                onFilterChange={onFilterChange}
                currentUrlParams={currentUrlParams}
            />
            <div className="table-action-bar">
                <RefreshButton reloadData={reloadData} />
            </div>
        </div>
    );
